/**
 * Cloud Run browser isolation (opt-in via Vite env).
 *
 * Production and DEV builds leave VITE_CLOUD_RUN_ISOLATED unset, so this file
 * is a no-op there. Cloud CI sets the flag and blocks requests to production
 * hostnames that leftover dialpad/SIP code still hardcodes.
 */
const enabled = import.meta.env.VITE_CLOUD_RUN_ISOLATED === 'true'
const blockedSuffixes = String(
  import.meta.env.VITE_CLOUD_PRODUCTION_HOST_BLOCKLIST || 'fivestarjob.ca',
)
  .split(',')
  .map((value) => value.trim().replace(/\.$/, '').toLowerCase())
  .filter(Boolean)

function assertCloudSafeUrl(value) {
  if (!enabled || !value) return
  const raw = typeof value === 'string' ? value : value.url
  let hostname
  try {
    hostname = new URL(raw, window.location.href).hostname
      .replace(/\.$/, '')
      .toLowerCase()
  } catch {
    return
  }
  const blocked = blockedSuffixes.some(
    (suffix) => hostname === suffix || hostname.endsWith(`.${suffix}`),
  )
  if (blocked) {
    throw new Error(`Cloud isolation blocked production host: ${hostname}`)
  }
}

if (enabled && typeof window !== 'undefined') {
  const nativeFetch = window.fetch.bind(window)
  window.fetch = (input, init) => {
    assertCloudSafeUrl(input)
    return nativeFetch(input, init)
  }

  const nativeXhrOpen = XMLHttpRequest.prototype.open
  XMLHttpRequest.prototype.open = function guardedOpen(method, url, ...args) {
    assertCloudSafeUrl(url)
    return nativeXhrOpen.call(this, method, url, ...args)
  }

  if (window.WebSocket) {
    const NativeWebSocket = window.WebSocket
    window.WebSocket = function GuardedWebSocket(url, protocols) {
      assertCloudSafeUrl(url)
      return protocols === undefined
        ? new NativeWebSocket(url)
        : new NativeWebSocket(url, protocols)
    }
    window.WebSocket.prototype = NativeWebSocket.prototype
    Object.assign(window.WebSocket, NativeWebSocket)
  }
}
